import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';
import {FileImportStatus, UploadCard} from '@services';

@Component({
    selector: 'app-upload-card',
    standalone: true,
    imports: [NgClass],
    templateUrl: './upload-card.component.html',
    styleUrls: ['./upload-card.component.scss']
})
export class UploadCardComponent {
    @Input({required: true}) card!: UploadCard;
    @Input() expanded = false;

    @Output() minimize = new EventEmitter<string>();
    @Output() maximize = new EventEmitter<string>();
    @Output() closeCard = new EventEmitter<string>();

    get displayLines(): string[] {
        return this.card.messageLines
            .join('\n')
            .split('\n')
            .map(line => line.trimEnd())
            .filter(line => line.trim().length > 0);
    }

    get statusLabel(): string {
        switch (this.card.status) {
            case FileImportStatus.Uploading:
                return 'Uploading…';
            case FileImportStatus.Processing:
                return 'Processing…';
            case FileImportStatus.Completed:
                return 'Completed';
            case FileImportStatus.Failed:
                return 'Failed';
        }
    }

    get statusClass(): string {
        switch (this.card.status) {
            case FileImportStatus.Completed:
                return 'text-success';
            case FileImportStatus.Failed:
                return 'text-danger';
            default:
                return '';
        }
    }

    get progressBarClass(): string {
        switch (this.card.status) {
            case FileImportStatus.Completed:
                return 'progress-bar bg-success';
            case FileImportStatus.Failed:
                return 'progress-bar bg-danger';
            default:
                return 'progress-bar progress-bar-striped progress-bar-animated bg-primary';
        }
    }

    get progressWidth(): string {
        return this.card.status === FileImportStatus.Failed ? '20%' : '100%';
    }
}
